import './index.css';
import { View } from '../../../component';
import { TiDeleteOutline } from 'react-icons/ti';
import Modal from '@mui/material/Modal';
import ReactPlayer from 'react-player';
import { assetsLink } from '../../../utilities/helper';
import React from 'react';

interface Props {
  visible: boolean;
  onPressClose: any;
}
const YesNoVideo = ({ visible, onPressClose }: Props) => {
  return (
    <Modal open={visible} onClose={onPressClose}>
      <View
        style={{
          width: '320px'
        }}>
        <View
          style={{
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative'
          }}>
          <ReactPlayer
            width={'100%'}
            height={'100%'}
            url={`${assetsLink}yes_no_how_to_play.mp4`}
            controls={true}
            playing={true}
          />
          <View
            style={{
              right: 0,
              top: 0
            }}
            onPress={onPressClose}
            className={'YesNoVideo__CloseBtn'}>
            <TiDeleteOutline size={30} color={'#005089'} />
          </View>
        </View>
      </View>
    </Modal>
  );
};
export default React.memo(YesNoVideo);
